import { useMutation, useQueryClient } from "@tanstack/react-query";

import { aiAgentKnowledgeBaseQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/queries/queryKeyFactory";
import type { KnowledgeBasePayload } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/types";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useUpdateCustomization = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (data: KnowledgeBasePayload) => {
            return await salesApiService.aiAgent.knowledgeBase.updateCustomization(data);
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: aiAgentKnowledgeBaseQueryKeys.customization() });
        },
    });
};
